"use client";

import { CompositeContextProvider, CompositeScopedContextProvider } from "./APGXEJ2Q.js";
import { PopoverContextProvider, PopoverScopedContextProvider } from "./COWZSPJ7.js";
import { createStoreContext } from "./7FZLUSKW.js";

// src/combobox/combobox-context.tsx
import { createContext } from "react";
var ComboboxListRoleContext = createContext(void 0);
var ctx = createStoreContext([PopoverContextProvider, CompositeContextProvider], [PopoverScopedContextProvider, CompositeScopedContextProvider]);
var useComboboxContext = ctx.useContext;
var useComboboxScopedContext = ctx.useScopedContext;
var useComboboxProviderContext = ctx.useProviderContext;
var ComboboxContextProvider = ctx.ContextProvider;
var ComboboxScopedContextProvider = ctx.ScopedContextProvider;
var ComboboxItemValueContext = createContext(void 0);
var ComboboxItemCheckedContext = createContext(false);
export { ComboboxListRoleContext, useComboboxContext, useComboboxScopedContext, useComboboxProviderContext, ComboboxContextProvider, ComboboxScopedContextProvider, ComboboxItemValueContext, ComboboxItemCheckedContext };